import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import Topbar from '../layout/Topbar';
import { getUtente, modificaUtente } from '../../actions/auth';

const ModificaUtente = ({ auth: { user, loading, utente }, getUtente, modificaUtente, alert, getRuoli }) => {

    let { idUtente } = useParams();


    const initialState = {
        username: "",
        email: "",
        ruolo: "",
        nuova_password: "",
        ripeti_password: ""
    }



    const [utenteData, setUtenteData] = useState(initialState);

    const { username, email, ruolo, nuova_password, ripeti_password } = utenteData;

    useEffect(() => {
        getUtente({ idUtente: idUtente });
    }, []);


    useEffect(() => {
        setUtenteData({
            _id: loading || !utente ? '' : utente._id,
            username: loading || !utente ? '' : utente.username,
            email: loading || !utente ? '' : utente.email,
            ruolo: loading || !utente ? '' : utente.ruolo,
            nuova_password: "",
            ripeti_password: ""
        });
    }, [utente, loading]);

    if (user && user.ruolo !== 'admin') {
        return <Redirect to="/" />;
    }

    const onChange = e => {
        setUtenteData({ ...utenteData, [e.target.name]: e.target.value });
    }

    const onSubmit = async e => {
        e.preventDefault();
        modificaUtente({ idUtente, username, email, ruolo, nuova_password, ripeti_password });
    };

    return (loading ? <Spinner /> :
        <div className="section lightblue user-block wf-section">
            <Topbar
                labelPagina={"Gestione Utenti"}
                isFolder={false}
            />
            <div className="container flex-center">
                <div className="form-wrap wide">
                    <div className="form-block w-form">
                        <form id="wf-form-registrazione" name="wf-form-registrazione" data-name="registrazione" className="form" onSubmit={e => onSubmit(e)}  autoComplete="off">
                            <h3 id="w-node-e7570c72-74ce-9da3-f85d-1baca43dd698-1ef19627" className="no-margin">Modifica utente</h3>
                            <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                                <label htmlFor="username" className="form-label">username <span className="required">*</span></label>
                                <input type="text" className="input-field w-input" maxLength="256" name="username" data-name="username" placeholder="username" id="username" value={username} onChange={e => onChange(e)} required="true" />
                            </div>
                            <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                                <label htmlFor="email" className="form-label">email <span className="required">*</span></label>
                                <input type="text" className="input-field w-input" maxLength="256" name="email" data-name="email" placeholder="email" id="email" value={email} onChange={e => onChange(e)} required="true" />
                            </div>
                            <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                                <label htmlFor="ruolo" className="form-label">ruolo <span className="required">*</span></label>
                                <select
                                    className="input-field w-input"
                                    name="ruolo"
                                    data-name="ruolo"
                                    id="ruolo"
                                    value={ruolo || ""}
                                    onChange={e => setUtenteData({ ...utenteData, ruolo: e.target.value })}
                                    required="true"
                                >
                                    <option value="">Seleziona ruolo</option>
                                    <option key="admin" value="admin" selected={ruolo == "admin"}>admin</option>
                                    <option key="magazziniere" value="magazziniere" selected={ruolo == "magazziniere"}>magazziniere</option>
                                </select>
                            </div>
                            <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                                <span></span>
                            </div>
                            <div id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99dd-240c86e7" className="column">
                                <label for="nuova_password" className="form-label">Nuova password </label>
                                <input type="password" className="input-field w-input" maxlength="256" name="nuova_password" data-name="nuova_password" placeholder="Inserisci password" id="nuova_password" value={nuova_password} onChange={e => onChange(e)} autoComplete="off"/>
                            </div>
                            <div id="w-node-_6aab59d1-f84d-b2bd-8cd4-f48b91ca99dd-240c86e7" className="column">
                                <label for="ripeti_password" className="form-label">Ripeti password </label>
                                <input type="password" className="input-field w-input" maxlength="256" name="ripeti_password" data-name="ripeti_password" placeholder="Ripeti password" id="ripeti_password" value={ripeti_password} onChange={e => onChange(e)} />
                            </div>
                            <input type="submit" value="Salva" data-wait="Un attimo..." id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d2b-40413f47" className="submit-button w-button" />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

ModificaUtente.propTypes = {
    auth: PropTypes.object.isRequired,
    alert: PropTypes.object.isRequired,
    getUtente: PropTypes.func.isRequired,
    modificaUtente: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth,
    alert: state.alert
});

export default connect(mapStateToProps, { getUtente, modificaUtente })(ModificaUtente);
